import React, { useEffect, useState } from 'react';
import RoleManagement from './RoleManagement';
import { toast } from 'react-toastify';
import axios from 'axios';

const RoleManager = ({onclose}) => {
    const [roles, setRoles] = useState([]);
    const [resources, setResources] = useState([]);
    const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));

    useEffect(() => {
        let isMounted = true;
        const fetchRoles = async () => {
            try {
                const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/roles/get-all-roles?hospitalId=${userDetails.hospitalId}`);
                if (isMounted) {
                    setRoles(res.data.roles);
                    const formatedResources = res.data.roles.map((role) => role.roleName);
                    setResources([...formatedResources]);
                }
            } catch (error) {
                if (isMounted) {
                    console.log(error);
                    toast.error(error.response?.data.error || "Unexpected Error...", { position: "top-center" });
                }
            }
        };
        fetchRoles();
        return () => {
            isMounted = false;
        };
    }, [userDetails.hospitalId]);

    const addRole = async (newRole) => {
        try {
            const role = { ...newRole, hospitalId: userDetails.hospitalId };
            const res = await axios.post(`${process.env.REACT_APP_BASE_URL}/roles/add`, role);
            toast.success("Role added successfully....", { position: "top-center" });
            setRoles([...roles, { ...newRole, _id: res.data.role._id }]);
        } catch (error) {
            console.log(error);
            toast.error(error.response?.data.error || "While adding role, an unexpected error occurred...", { position: "top-center" });
        }
    };

    const editRole = async (roleId, updatedRole) => {
        try {
            await axios.put(`${process.env.REACT_APP_BASE_URL}/roles/update/${roleId}`, updatedRole);
            toast.success("Role updated successfully....", { position: "top-center" });
            setRoles(roles.map((role) => (role._id === roleId ? { ...updatedRole, _id: roleId } : role)));
        } catch (error) {
            console.log(error);
            toast.error(error.response?.data.error || "While updating role, an unexpected error occurred...", { position: "top-center" });
        }
    };

    const deleteRole = async (roleId) => {
        try {
            const res = await axios.delete(`${process.env.REACT_APP_BASE_URL}/roles/delete/${roleId}`);
            toast.success(res?.data.message, { position: "top-center" });
            setRoles(roles.filter((role) => role._id !== roleId));
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data.error || "While deleting role, an unexpected error occurred...");
        }
    };

    return (
        <div>
            <p className="back-link" onClick={onclose}>
        Back
      </p>
            <RoleManagement
                roles={roles}
                resources={resources}
                onAddRole={addRole}
                onEditRole={editRole}
                onDeleteRole={deleteRole}
            />
        </div>
    );
};

export default RoleManager;
